<template>
  <div class="vote-container" :style="{
    'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
    'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
  }">
    <div class="group-list" :style="{
      'background': `url(${cc.bg}) no-repeat center/contain`
    }">
      <div class="group" v-for="(group, index) in group_list" :key="index">
        <h2 class="group-name" :style="{'color': gc.main_color}">
          {{group.group_name}}
          <div class="border-bottom" :style="{'background-color': gc.main_color}"></div>
        </h2>
        <div class="team-list">
          <div class="team" v-for="team in group.teams" :key="team.team_name" @click="select(index, team)" :style="{
            'background-color': team.is_voted ? hexToRgba(gc.main_color, .5) : slected_teams[index].includes(team.team_id) ? gc.main_color : '',
          }">
            <div class="border" :style="{
              'border': `1px solid ${team.is_voted ? hexToRgba(gc.main_color, .5) : gc.main_color}`,
              'opacity': slected_teams[index].includes(team.team_id) ? '1' : '.5'
              }"></div>
            <svg v-if="team.is_voted || slected_teams[index].includes(team.team_id)" width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.75 7L0 3.11111L1.5 1.55556L3.75 3.88889L7.5 0L9 1.55556L3.75 7Z" :fill="gc.text_color"/>
            </svg>
            <span class="rank" v-if="group.is_voted && team.rank" :style="{
              'background-color': gc.main_color,
              'color': gc.text_color
            }">{{team.rank}}</span>
            <div class="img-box">
              <img :src="team.img" alt="">
            </div>
            <p class="name" :style="{
              'color': team.is_voted || slected_teams[index].includes(team.team_id) ? gc.text_color : gc.main_color,
              'opacity': slected_teams.includes(team.team_id) ? '1' : '.7'
              }">{{team.team_name}}</p>
            <p class="vote-desc" :style="{
              'color': team.is_voted || slected_teams[index].includes(team.team_id) ? gc.text_color : gc.main_color,
              'opacity': slected_teams[index].includes(team.team_id) ? '1' : '.7'
            }">已投{{team.vote_num}}票</p>
          </div>
        </div>
      </div>
    </div>
    <div class="submit-btn" :style="{
      'background': `url(${cc.btn_bg}) no-repeat center/contain`,
      'color': gc.text_color,
      'opacity': cd.is_voted ? '.6': '1'
      }">提交我的预测</div>
    <p class="left-time" :style="{'color': gc.main_color}">还剩 {{calcTime}} 截止预测，提交后不能修改</p>
  </div>
</template>

<script>
import { utils } from '_lib/utils'
import { ComponentCommonMixin } from '../mixin'
export default {
  mixins: [ComponentCommonMixin],
  data () {
    return {
      slected_teams: [],
      group_list: [],
      seconds: 0,
    }
  },
  created() {
    this.initialCountDown()
  },
  mounted () {
    
    this.group_list = this.cd.group_list
    // 给每个小组都创建一个数组，用于存放该小组所选择的
    this.slected_teams = this.group_list.map(() => [])
  },
  computed: {
    calcTime () {
      const day = this.getTimeNumber('day') == 0 ? '' : `${this.getTimeNumber('day')}天`
      return `${day}${this.getTimeNumber('hour', 0)}${this.getTimeNumber('hour', 1)}:${this.getTimeNumber('minute', 0)}${this.getTimeNumber('minute', 1)}:${this.getTimeNumber('second', 0)}${this.getTimeNumber('second', 1)}`
    }
    
  },
  methods: {
    // 选择某一队某个队伍
    select (groupIndex, team) {
      if (this.group_list[groupIndex].is_voted) {
        return
      }
      const index = this.slected_teams[groupIndex].indexOf(team.team_id)
      if (index === -1) {
        if (this.group_list[groupIndex].max_select_num <= this.slected_teams[groupIndex].length) {
          return
        }
        this.slected_teams[groupIndex].push(team.team_id)
      } else {
        this.slected_teams[groupIndex].splice(index, 1)
      }
    },
    submit () {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
    },
    getTimeNumber (type, index) {
      var seconds = this.seconds % 60
      var minutes = Math.floor(this.seconds / 60) % 60
      var hours = Math.floor(Math.floor(this.seconds / 60) / 60) % 24
      var days = Math.floor(Math.floor(Math.floor(this.seconds / 60) / 60) / 24)
      var num = 0
      switch (type) {
        case 'day':
          num = ('' + days).length === 1 ? '0' + days : days
          break;
        case 'hour':
          if (index == 1) {
            num = hours%10
          } else if (index == 0) {
            num = Math.floor(hours/10)
          }
          break;
        case 'minute':
          if (index == 1) {
            num = minutes%10
          } else if (index == 0) {
            num = Math.floor(minutes/10)
          }
          break;
        case 'second':
          if (index == 1) {
            num = seconds%10
          } else if (index == 0) {
            num = Math.floor(seconds/10)
          }
      }
      return num
    },
    initialCountDown () {
      clearInterval(this.timer)
      this.seconds = this.cd.left_time
      this.timer = setInterval(() => {
        this.seconds--
        if (this.seconds == 0) {
          if (this.state_d == 1) {
            this.state_d = 2
          }
        }
      }, 1000)
    }
  },
}
</script>

<style lang="less" scoped>
.vote-container {
  margin: 32px 14px 0;
  
  .group-list {
    display: flex;
    flex-wrap: wrap;
    .group {
      flex: 1;
      background: linear-gradient(180deg, #EDF1FF 0%, #C7D3FF 100%);
      width: calc(50% - 3.5px);
      &:nth-child(odd) {
        margin-right: 7px;
      }
      .group-name {
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        padding: 7px 0;
        position: relative;
        .border-bottom {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 200%;
          height: 1px;
          opacity: .2;
          transform-origin: 0 0;
          transform: scale(0.5, 0.5);
        }
      }
      .team-list {
        display: flex;
        flex-wrap: wrap;
        padding: 10px 9px 0;
        .team {
          width: calc(50% - 5px);
          padding: 10px 0 5px;
          position: relative;
          margin-bottom: 10px;
          .border {
            position: absolute;
            top: 0;
            left: 0;
            width: 200%;
            height: 200%;
            transform-origin: 0 0;
            transform: scale(0.5, 0.5);
            pointer-events: none;
            opacity: .5;
          }
          svg {
            position: absolute;
            top: 3px;
            right: 3px;
          }
          .rank {
            font-family: ALIBABA Font;
            position: absolute;
            left: 0;
            top: 0;
            width: 14px;
            height: 14px;
            font-size: 12px;
            line-height: 14px;
            text-align: center;
          }
          &:nth-child(odd) {
            margin-right: 10px;
          }
          .img-box {
            height: 33px;
            margin: 0 auto;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .name {
            font-weight: 600;
            font-size: 12px;
            line-height: 17px;
            opacity: .7;
            text-align: center;
            margin-top: 2px;
          }
          .vote-desc {
            white-space: nowrap;
            font-size: 18px;
            line-height: 26px;
            opacity: .7;
            text-align: center;
            // transform: scale(0.5);
            // transform-origin: top;
            zoom: .5;
          }
        }
      }
    }
    
  }
  .submit-btn {
    margin: 14px auto 6px;
    width: 255px;
    height: 40px;
    font-weight: 600;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
  }
  .left-time {
    font-size: 11px;
    line-height: 15px;
    text-align: center;
    opacity: .7;
  }
}
</style>